import React from 'react'
import { Box, Button, Divider, Text } from '@chakra-ui/react'
import { useNavigate } from "react-router";
import { Auth, Cache } from "aws-amplify";
import { deleteCookieString } from '../../utils/cookie';
import './Header.scss'

export const Header = ({ className }) => {

  const navigate = useNavigate()

  const logOut = async () => {
    try {
      Cache.clear();
      document.cookie = deleteCookieString(`dyn_session`);
      localStorage.clear();
      sessionStorage.clear();
      await Auth.signOut();
      navigate("/");
      window.location.reload();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  return (
    <Box className={`${className} header-container`}>
      <Box boxShadow='md' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Text className='logo' sx={{ margin: "0 20px 0 10px" }}>EdShopify</Text>
        </Box>
        <Button colorScheme="blue" onClick={logOut}>Logout</Button>
      </Box>
      <Divider />
    </Box>
  )
}
